var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddTags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1740_8276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.1585 9.64996L9.6585 2.14996C9.9585 1.84996 10.3752 1.66663 10.8335 1.66663H16.6668C17.5835 1.66663 18.3335 2.41663 18.3335 3.33329V9.16663C18.3335 9.62496 18.1502 10.0416 17.8418 10.35L10.3418 17.85C10.0418 18.15 9.62516 18.3333 9.16683 18.3333C8.7085 18.3333 8.29183 18.15 7.99183 17.8416L2.1585 12.0083C1.85016 11.7083 1.66683 11.2916 1.66683 10.8333C1.66683 10.375 1.8585 9.94996 2.1585 9.64996ZM15.4168 5.83329C16.1085 5.83329 16.6668 5.27496 16.6668 4.58329C16.6668 3.89163 16.1085 3.33329 15.4168 3.33329C14.7252 3.33329 14.1668 3.89163 14.1668 4.58329C14.1668 5.27496 14.7252 5.83329 15.4168 5.83329Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1740_8276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "matrix(-1 0 0 1 20 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTags);
export default __webpack_public_path__ + "static/media/addTags.0513c375c95dffa9fabe36ad5bdc8f3d.svg";
export { ForwardRef as ReactComponent };